import React, { useMemo } from 'react';
import LeafletMap from '../../components/LeafletMap';
import { Page } from '../../components/ui/Page'
import Store from '../../store/Store';
import { Body } from '../../components/layout/Body';

export interface MapSearchPageProps {
	id?: string;
}

export default function MapSearchPage(props: MapSearchPageProps) {
	const searchOrders = Store.use('searchOrders');

	const mapSetup = useMemo(() => {
		let timeout: ReturnType<typeof setTimeout> | undefined;
		return {
			onUpdateView: (view: { diag: number; center: { lat: number; lng: number } }) => {
				if (timeout != null) clearTimeout(timeout);
				timeout = setTimeout(() => {
					const dist = Math.min(Math.max(Math.floor(view.diag * 0.4), 100), 500000);
					Store.loadSearchWithin(view.center.lat, view.center.lng, dist);
				}, 1000);
			},
		};
	}, []);

	return (
		<Page>
			<Body title="Standort Suche">
				<LeafletMap
					setup={mapSetup}
					dateSearch
					geoSearch
					showOrders
					orders={searchOrders}
					viewCache="extern_map"
				/>
			</Body>
		</Page>
	);
}
